import { useFormikWithoutDirtyForm } from "@shared";

import { useDropdownOptions } from "@/common/hooks/useDropdownOptions";
import { ClientsFilterType } from "@/pages/clients/clients/Clients.types";

export function useClientsSearch(
  initialFilters: ClientsFilterType | null,
  onSearch: (filters: ClientsFilterType) => Promise<void>,
  onClose: () => void
) {
  const dropdownOptions = useDropdownOptions();

  const formik = useFormikWithoutDirtyForm<ClientsFilterType>({
    initialValues: {
      searchText: initialFilters?.searchText ?? null,
      salutation: initialFilters?.salutation ?? null,
      title: initialFilters?.title ?? null,
      name: initialFilters?.name ?? null,
      birthday: initialFilters?.birthday ?? null,
      insuranceNumber: initialFilters?.insuranceNumber ?? null,
      caseNumber: initialFilters?.caseNumber ?? null,
      srvFileNumber: initialFilters?.srvFileNumber ?? null,
      courtId: initialFilters?.courtId ?? null,
      street: initialFilters?.street ?? null,
      zipCode: initialFilters?.zipCode ?? null,
      city: initialFilters?.city ?? null,
      nationality: initialFilters?.nationality ?? null,
      mediaInquiry: initialFilters?.mediaInquiry ?? null,
      caseNoteDateFrom: initialFilters?.caseNoteDateFrom ?? null,
      caseNoteDateTo: initialFilters?.caseNoteDateTo ?? null,
      caseNoteKeyword: initialFilters?.caseNoteKeyword ?? null,
      assignedCounselorId: initialFilters?.assignedCounselorId ?? null,
      status: initialFilters?.status ?? null,
    },
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    onSubmit: async (values) => {
      await onSearch(values);
      onClose();
    },
  });

  return { formik, dropdownOptions };
}
